import axiosInstance from '../axios-instance';
import * as Constants from '../constants';

const getBetterHrTotAmountData = (widgetId: string, count: number) => {
    return axiosInstance.get(`${Constants.REACT_APP_NODE_BACKEND_URL}/widgets/better-hr/calculate-amount/${widgetId}/${count}`);
}

export {
    getBetterHrTotAmountData
};